export default "__VITE_PUBLIC_ASSET__aad0c5ea__"